// extracted by mini-css-extract-plugin
export var locationCard = "_fj-0";